import {
  ArrowPathIcon,
  CheckBadgeIcon,
  StarIcon,
} from "@heroicons/react/20/solid";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Search(props) {
  const [products, setProducts] = useState([]);

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  useEffect(() => {
    axios
      .get(`https://dealersonly.parts/beta/api/products?search=${props.query}`)
      .then((res) => {
        setProducts(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [props.query]);

  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });

  return (
    <div className="-mx-px grid grid-cols-2 border-gray-200 md:grid-cols-3 lg:grid-cols-4 bg-white rounded-md sm:mx-4">
      {products.length !== 0 ? (
        products?.map((product) => (
          <div
            key={product._id}
            className={`group relative border-t border-b border-gray-200 bg-white shadow-sm sm:rounded-lg sm:border p-4 m-1 ${
              product.active ? "" : "opacity-50"
            }`}
          >
            {product.oem === "Original" ? (
              <div className="flex items-center text-sm font-medium text-indigo-600 mb-2 z-10">
                <CheckBadgeIcon
                  className="mr-2 h-6 w-6 flex-none"
                  aria-hidden="true"
                />
                <p>OEM Part</p>
              </div>
            ) : (
              <div className="flex items-center text-sm font-medium text-red-50-600 mb-2 z-10 invisible">
                <ArrowPathIcon
                  className="mr-2 h-6 w-6 flex-none"
                  aria-hidden="true"
                />
                <p>Aftermarket</p>
              </div>
            )}
            <div className="aspect-w-1 aspect-w-1-custom aspect-h-1 overflow-hidden rounded-lg bg-gray-200 group-hover:opacity-75">
              <img
                src={
                  product.productImages &&
                  product.productImages[0] &&
                  product.productImages[0]
                    ? "https://dealersonly.parts/beta/app/" +
                      product.productImages[0]
                    : "https://dealersonly.parts/beta/app/files/DopePlaceholder.png"
                }
                alt="Artikelbild"
                className="h-full w-full object-cover object-center"
              />
            </div>
            <div className="pt-2 pb-4 text-center">
              <p className="font-light italic">{product.category}</p>
              <h3 className="text-lg font-medium text-gray-900">
                {product.active ? (
                  <Link to={`product/${product.handle}`}>
                    <span aria-hidden="true" className="absolute inset-0" />
                    {product.title}
                  </Link>
                ) : (
                  product.title
                )}
              </h3>

              <p className="mt-2 text-base font-medium text-gray-900">
                {formatter.format(product.price)}
              </p>
              <div className="flex gap-2">
                {product.selector === "parts" ? (
                  product.teileNummer &&
                  product.teileNummer.map((element) => {
                    return (
                      <p className="font-light bg-gray-100 mt-2 text-xs rounded-md">
                        {element ? `#${element}` : ""}
                      </p>
                    );
                  })
                ) : (
                  <>
                    <p className="font-normal bg-gray-100 mt-2 text-xs rounded-md p-1">
                      {product.category}
                    </p>
                    <p className="font-normal bg-gray-100 mt-2 text-xs rounded-md p-1">
                      {product.baujahr}
                    </p>
                    <p className="font-normal bg-gray-100 mt-2 text-xs rounded-md p-1">
                      {product.motor}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="relative p-4 sm:p-6">
          Keine Parts mit dieser Nummer gefunden
        </div>
      )}
    </div>
  );
}

export default Search;
